import { Modal } from "antd";

export const showUnsavedChangesConfirm = (onConfirm: () => void) => {
    Modal.confirm({
        title: "Änderungen verwerfen?",
        content: "Alle nicht gespeicherten Änderungen gehen verloren. Bist du sicher, dass du den Dialog schließen möchtest?",
        okText: "Ja, schließen",
        cancelText: "Abbrechen",
        onOk: onConfirm
    });
};
